import React from 'react';
import Modal from '../common/Modal';
import Button from '../ui/Button';
import InputField from '../ui/InputField';

const CandidateDeclineRejectionModal = ({
  text,
  value = '',
  setValue = false,
  loading,
  confirm,
  type = 'number',
  ...restModalProps
}) => {
  const {onClose} = restModalProps;
  return (
    <Modal {...restModalProps}>
      <div className="flex flex-col gap-8 p-4">
        <div className="text-center text-2xl font-semibold">
          {`Please enter candidate ${text}`}
        </div>

        {type === 'text' && (
          <InputField
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        )}
        {type === 'number' && (
          <InputField
            value={value}
            type="number"
            onChange={(e) => setValue(e.target.value)}
          />
        )}

        <div className="flex justify-center gap-8">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            text="Confirm"
            className="bg-red-500 hover:bg-red-800 text-white font-normal py-2 px-4 rounded"
            onClick={confirm}
            loading={loading}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CandidateDeclineRejectionModal;
